import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { payTuinaPurchaseOrder } from '@/service/tuina'
import PurchasePayForm from './PurchasePayForm'

class PurchasePayModal extends React.Component {
  modalRef = React.createRef()

  static propTypes = {
    children: PropTypes.node,
    orderNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    payMethod: PropTypes.string,
    zIndex: PropTypes.number,
    onSuccess: PropTypes.func
  }

  state = {
    orderNo: '',
    payMethod: undefined
  }

  show = (orderNo, payMethod) => {
    this.setState({ orderNo, payMethod }, () => {
      this.modalRef.current?.showModal?.({ stopPropagation: () => {} })
    })
  }

  handleOk = async () => {
    const { onSuccess } = this.props
    const orderNo = this.state.orderNo || this.props.orderNo
    const payMethod = this.state.payMethod || this.props.payMethod
    await payTuinaPurchaseOrder({
      orderNo,
      payMethod
    })
    message.success('支付已确认')
    if (typeof onSuccess === 'function') onSuccess()
  }

  render () {
    const { children, zIndex } = this.props
    const orderNo = this.state.orderNo || this.props.orderNo
    const payMethod = this.state.payMethod || this.props.payMethod
    return (
      <WrappedModal
        ref={this.modalRef}
        children={children}
        title="支付待确认"
        okText="确认支付"
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={480}
        zIndex={zIndex}
        maskClosable={false}
        closable={false}
        keyboard={false}
        destroyOnClose
        baseComponent={<PurchasePayForm />}
        baseProps={{ orderNo, payMethod }}
        onOk={this.handleOk}
      />
    )
  }
}

export default PurchasePayModal
